'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _uk_UA = require('../../date-picker/locale/uk_UA');

var _uk_UA2 = _interopRequireDefault(_uk_UA);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _uk_UA2['default'];